import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Resume = ({ data }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  if (!data) return null;

  const { skillmessage, work: workData, skills: skillsData } = data;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeInOut" } },
  };
  
  const skillVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeInOut" } },
  };

  const work = workData.map((work) => (
    <motion.div key={work.company} className="work-entry" variants={itemVariants}>
      <div className="work-timeline-dot"></div>
      <div className="work-content">
        <h3>{work.company}</h3>
        <p className="info">
          {work.title}
          <span>&bull;</span> <em className="date">{work.years}</em>
        </p>
        <p className="info2">{work.description}</p>
      </div>
    </motion.div>
  ));

  const skills = skillsData.map((skill) => {
    const projectImage = "images/technology/" + skill.image;
    return (
      <motion.div 
        key={skill.name} 
        className="skill-card" 
        variants={skillVariants}
        whileHover={{ y: -10, scale: 1.02, transition: { duration: 0.3 } }}
      >
        <div className="skill-icon">
          <img alt={skill.name} src={projectImage} />
        </div>
        <h6 className="skill-name">{skill.name}</h6>
      </motion.div>
    );
  });

  return (
    <section id="resume" ref={ref}>
      <div className="row work">
        <div className="three columns header-col">
          <h1>
            <span>Work</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <motion.div
            className="work-timeline"
            variants={containerVariants}
            initial="hidden"
            animate={controls}
          >
            {work}
          </motion.div>
        </div>
      </div>

      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>{skillmessage}</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <motion.div
             className="skills-grid-container"
             variants={containerVariants}
             initial="hidden" 
             animate={controls}
          >
            {skills}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Resume;

// <p>{skillmessage}
//             </p>

// 				<div className="bars">
// 				   <ul className="skills">
// 					  {skills}
// 					</ul>
// 				</div>
